import { render, staticRenderFns } from "./createCoupon.vue?vue&type=template&id=2337c44e&scoped=true&"
import script from "./createCoupon.vue?vue&type=script&lang=ts&"
export * from "./createCoupon.vue?vue&type=script&lang=ts&"
import style0 from "./createCoupon.vue?vue&type=style&index=0&id=2337c44e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2337c44e",
  null
  
)

export default component.exports